import _ from 'lodash'
import * as largeView from './large/index'
import * as smallView from './small/index'
import config from './config.json'
import siteConfig from '../../abt-core/site-config.json'
import { composeTest } from '../../abt-utils/structure'

var liveConfig = _.find(window[siteConfig.imgServerConfig], { id: 'abt543' }) || {}

export default composeTest(config, liveConfig, {
  largeView: largeView,
  smallView: smallView
})



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt543/test.js
 ** module id = 59
 ** module chunks = 2
 **/